type ProblemDetails = {
  detail?: string;
  title?: string;
};

export const RAW_MESSAGE = { nsSeparator: false, keySeparator: false };

export function reportWorkflowError(
  error: unknown,
  fallbackKey: string,
  enqueueError: (messageOrKey: string, options?: object) => void
) {
  if (typeof error === 'string') {
    return;
  }

  const problem = error as ProblemDetails | null;
  const message = problem?.detail || problem?.title;

  if (message) {
    enqueueError(message, RAW_MESSAGE);
  } else {
    enqueueError(fallbackKey);
  }
}
